import { tns } from 'tiny-slider/src/tiny-slider'
import 'tiny-slider/dist/tiny-slider.css'

import Mixins from '@/base/mixins'

export default class FeatureInteractive extends Mixins {
  constructor(sliderElement) {
    super()

    this.slider = null
    this.slides = null
    this.titles = []
    this.sliderElement = sliderElement

    this.slideSelector = '.js-feature-interactive-block-slide'
  }

  initSlider() {
    this.getTitles()

    this.slider = tns({
      container: this.sliderElement,
      controls: false,
      gutter: 10,
      loop: false,
      nav: true,
      speed: 1000,
      autoHeight: false,
      mouseDrag: true,
      navPosition: 'bottom',
      onInit: (info) => {
        for (let i = 0; i < info.navItems.length; i++) {
          if (this.titles[i].link) {
            info.navItems[i].innerHTML = `<span class="feature-interactive-block__bullet-title">
                                            <a tabindex="-1" href="${this.titles[i].link}">${this.titles[i].title}</a>
                                          </span>`
          } else {
            info.navItems[i].innerHTML = `<span class="feature-interactive-block__bullet-title">
                                            <span>${this.titles[i].title}</span>
                                          </span>`
          }

          info.navItems[i].setAttribute('tabindex', 0)
          info.navItems[i].setAttribute('tabindex', 0)

          info.navItems[i].addEventListener('keyup', this.triggerClickByEnter)
          info.navItems[i].addEventListener('keyup', this.triggerClickByEnter)

          info.navItems[i].addEventListener('mouseover', () => {
            info.navItems[i].click()
          })
        }
      }
    })
  }

  getTitles() {
    this.slides = this.sliderElement.querySelectorAll(this.slideSelector)

    if (this.slides.length > 0) {
      this.slides.forEach((item) => {
        this.titles.push({ title: item.dataset.title, link: item.dataset.link ? item.dataset.link : '' })
      })
    }
  }
}
